<div class="navigation-link" [class.disabled]="disabled()"
     [routerLink]="!disabled() && subitems().length === 0 ? link() : null" routerLinkActive="active"
     (click)="onClick()">
    <div class="link-content">
        <i class="far {{icon()}}" [title]="text()"></i> <div class="nav-label">{{text()}}</div>
        @if (subitems().length > 0) {
            <i class="far" [class.fa-chevron-down]="isExpanded()" [class.fa-chevron-right]="!isExpanded()"></i>
        }
    </div>
</div>

<div class="subitems-container" [class.collapsed]="!isExpanded()"><!-- [@expandCollapse]="isExpanded() ? 'expanded' : 'collapsed'">-->
    <ng-content></ng-content>
</div>
